/**
 * OrbDocTutorialsIntermediateUiPatternsARDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocTutorialsIntermediateUiPatternsARDocScreen
 */

import { useOrbDocTutorialsIntermediateUiPatternsARDocScreenLogic } from '@/hooks/traits/useOrbDocTutorialsIntermediateUiPatternsARDocScreenLogic';
import type { OrbDocTutorialsIntermediateUiPatternsARDocScreenConfig } from '@/hooks/traits/useOrbDocTutorialsIntermediateUiPatternsARDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocTutorialsIntermediateUiPatternsARDocView as OrbDocTutorialsIntermediateUiPatternsARDocViewEntity } from '@app/shared';
import { OrbDocTutorialsIntermediateUiPatternsARDocBodyView } from '@/components/traits/OrbDocTutorialsIntermediateUiPatternsARDocBodyView';
import { OrbDocTutorialsIntermediateUiPatternsARDocFooterView } from '@/components/traits/OrbDocTutorialsIntermediateUiPatternsARDocFooterView';
import { OrbDocTutorialsIntermediateUiPatternsARDocHeaderView } from '@/components/traits/OrbDocTutorialsIntermediateUiPatternsARDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocTutorialsIntermediateUiPatternsARDocScreenViewProps {
  config?: Partial<OrbDocTutorialsIntermediateUiPatternsARDocScreenConfig>;
}

export function OrbDocTutorialsIntermediateUiPatternsARDocScreenView({ config: propsConfig }: OrbDocTutorialsIntermediateUiPatternsARDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocTutorialsIntermediateUiPatternsARDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocTutorialsIntermediateUiPatternsARDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocTutorialsIntermediateUiPatternsAR" trait="OrbDocTutorialsIntermediateUiPatternsARDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocTutorialsIntermediateUiPatternsARDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocTutorialsIntermediateUiPatternsARDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsIntermediateUiPatternsARDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsIntermediateUiPatternsARDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocTutorialsIntermediateUiPatternsARDocScreenView;
